import React, { FC, createContext, useCallback, useContext, useEffect } from 'react';
import { ViewWeb } from 'web/view/components/utils/web-view';
import './week-report.scss';
import { WeekReportDatePicker } from './week-report-date-picker';
import { PeriodTableRow } from '../production-report/p-report-period-table';
import { WeekReportTable } from './week-report-table';
import { SkioldIconSpinner } from 'web/view/components/utils/skiold-icon-spinner';
import PrinterGreyIcon from 'shared/assets/src-assets/png/printer_ikon_grey.png';
import { GetWeekReportPdf } from 'web/web-helpers/pdf-helper/production-report-helper';
import { savePdfAs } from 'web/web-helpers/pdf-helper/general-pdf-helper';
import { WebAppState } from 'web/state/store.web';
import { useSelector } from 'react-redux';
import { localized } from 'shared/state/i18n/i18n';

export interface PropsFromParent {
	setTopRight: (res: React.JSX.Element) => void;
}

interface WeekReportContextType {
	currentRows: PeriodTableRow[];
	setCurrentRows: React.Dispatch<React.SetStateAction<PeriodTableRow[]>>;
}

const WeekReportContext = createContext<WeekReportContextType>({} as WeekReportContextType);
export const useWeekReportContext = () => useContext<WeekReportContextType>(WeekReportContext);
export const WeekReportOverview: FC<PropsFromParent> = React.memo(props => {
	const [currentRows, setCurrentRows] = React.useState<PeriodTableRow[]>([]);

	const profile = useSelector((state: WebAppState) => state.profile.active!);

	const downloadPdf = useCallback(async () => {
		await GetWeekReportPdf(
			profile.siteId!,
			currentRows,
			Intl.DateTimeFormat().resolvedOptions().timeZone,
			profile.language!,
		).then(res => {
			savePdfAs(res, localized('WeekReport') + '.pdf');
		});
	}, [currentRows, profile.language, profile.siteId]);

	useEffect(() => {
		props.setTopRight(<SkioldIconSpinner title={'Print'} icon={PrinterGreyIcon} onPress={downloadPdf} />);
	}, [downloadPdf, props]);

	return (
		<WeekReportContext.Provider value={{ currentRows, setCurrentRows }}>
			<ViewWeb>
				<WeekReportDatePicker />
				<ViewWeb className="week-report-table">
					<WeekReportTable />
				</ViewWeb>
			</ViewWeb>
		</WeekReportContext.Provider>
	);
});
